export enum FOLDER_DIRECTORIES {
    MY_MATERIALS = 'purchased',
    MY_UPLOADS = 'own',
    WISHLIST = 'favorite'
}
